<template>
  <div class="page-content">
    <top-menu :setUser="setUser" :user="user" :key="user ? `top-menu-${user._id}` : 'top-menu'"></top-menu>
    <el-row type="flex" justify="center" class="page-body games-page">

      <el-col :xs="{span: 23}" :sm="{span: 24}" class="content-wrapper games-row">

        <background></background>

        <!---------------------------->
        <!-- System filter -->
        <!---------------------------->
        <drop-down-filter :isLoading="loadingSystems"
                      :onChange="getGames"
                      :icons="systemIcons"
                      :data="systems"
                      :placeholder="'Filter systems'"
                      :key="`systems-${cleanIndex}`"
        ></drop-down-filter>

        <!---------------------------->
        <!--  Game filters -->
        <!---------------------------->
        <text-filter :isLoading="loadingGames"
                    :onChange="getGames"
                    :placeholder="'Search by title'"
                   :key="`filter-${cleanIndex}`"
        ></text-filter>

        <!---------------------------->
        <!--  Game filters results-->
        <!---------------------------->
        <el-row style="margin-top: 1.5em;" type="flex" justify="left">
          <!--  Spacing -->
          <el-col :xs="{span: 1}" :sm="{span: 2}">
            <div style="height: 1px;"></div>
          </el-col>

          <!--  Result text -->
          <el-col :xs="{span: 21}" :sm="{span: 20}">
            <el-row type="flex" justify="left" class="fetch-date" style="text-align: left">

                <p class="clickable" @click="clearFilters" v-if="totalMatches">
                    Total matches: {{totalMatches}} <br>
                  <span v-if="systemFilter.length || gameFilter"> Clear filters <i class="el-icon-circle-close" ></i><br> </span>
                </p>

                <p v-else-if="(loadingSystems || loadingGames)"> Loading...</p>

                <p v-else> No matches :)</p>
            </el-row>
          </el-col>

          <!--  Spacing -->
          <el-col :xs="{span: 2}" :sm="{span: 2}">
            <div style="height: 1px;"></div>
          </el-col>

        </el-row>

        <!---------------------------->
        <!--  Game matches -->
        <!---------------------------->
        <el-row type="flex" justify="center">
          <el-col :xs="{span: 24}" :sm="{span: 24}">
            <games-table :loading="loadingGames"
                         :done="done"
                         :gameIcons="gameIcons"
                         :systemIcons="systemIcons"
                         :infinityScroll="true"
                         :games="games"
                         :getGames="getGames"
                         :addGameEnabled="false"
                         :isPeaking="false"
                         :exploringGameTagEnabled="true"
                         :refreshCacheOnGameEdit="true"
                         :showBorders="true"
                         :user="user"
                         :options="{
                                showHeader: true,
                                tableWidth: {
                                    xs: 22,
                                    sm: 20
                                },
                                gameHeaderOptions: {
                                    prefix: { show: true, xs: 0, sm: 1 },
                                    spacing: { show: true, xs: 2, sm: 1 },
                                    postfix: { show: true, xs: 0, sm: 1 },
                                    system: { show: true, xs: 4, sm: 4 },
                                    name: { show: true, xs: 14, sm: 13 },
                                    status: { show: true, xs: 4, sm: 4 },
                                },
                                gameRowOptions: {
                                    index: { show: true, xs: 1, sm: 1 },
                                    systemIcon: { show: true, xs: 3, sm: 2  },
                                    systemShortName: { show: true, xs: 0, sm: 2  },
                                    gameIcon: { show: true, xs: 0, sm: 1  },
                                    gameTitle: { show: true, xs: 19, sm: 15  },
                                    gameTag: { show: true, xs: 1, sm: 3  },
                                }
                             }"
            ></games-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <page-footer :key="'footer'"></page-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import MugenScroll from 'vue-mugen-scroll'

import TopMenu from '@/components/top-menu.vue'
import chunkArray from '@/utils/chunk-array.js'
import ErrorHandling from '@/utils/error-handling.js'
import Background from '@/components/background.vue'
import DropDownFilter from '@/components/drop-down-filter.vue'
import TextFilter from '@/components/text-filter.vue'
import PageFooter from '@/components/page-footer.vue'

import GamesTable from '@/components/games-table'

export default {
  name: 'Games',
  components: {
    TopMenu,
    MugenScroll,
    GamesTable,
    Background,
    DropDownFilter,
    TextFilter,
    PageFooter
  },
  data () {
    return {
      cleanIndex: 0,

      user: this.$store.state.user,

      loadingSystems: false,
      loadingGames: false,

      systemIcons: {},
      gameIcons: {},

      gameFilter: '',
      gameFilterCurrent: '',

      systemFilter: [],
      systemFilterCurrent: [],

      done: false,
      skip: 0,

      games: [],
      systems: [],

      systemsMap: {},
      totalMatches: 0
    }
  },
  mounted () {
    this.getSystems()
  },
  methods: {
    isEven (value) {
      return value % 2 === 0
    },
    to (name) {
      this.$router.push({ name: name })
    },
    chunkArray,

    setUser (user) {
      if (user) {
        this.$store.commit('user', user)
        this.user = user
      } else {
        this.$store.commit('user', false)
        this.user = false
        this.$router.push({ name: 'home', query: { mode: 'login' } })
      }
    },

    async getSystems () {
      if (this.loadingSystems) {
        this.$message.error('Already loading, please wait!')
        return
      }

      this.loadingSystems = true

      const res = await this.$http.get('systems')

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'systems', { handleMessage: this.$message.error })
        this.loadingSystems = false
      }

      else {
        for (let system of res.list) {
          this.systemsMap[system._id] = system

          if (this.systemIcons[system.avatar]) continue
          this.systemIcons[system.avatar] = require(`@/assets/${system.avatar}-mini.png`)
        }

        this.systems = res.list
        this.loadingSystems = false
      }
    },

    async clearFilters () {
      this.gameFilter = ''
      this.systemFilter = []

      this.cleanIndex += 1

      await this.getGames()
    },

    async getGames (opt = {}) {
      this.setFilters(opt)
      let hasSameFilters = this.checkIfFiltersChanged()

      if (this.done && hasSameFilters) return

      if (this.loadingGames) {
        this.$message.error('Already loading, please wait!')
        return
      }

      this.loadingGames = true

      if (!hasSameFilters) this.skip = 0
      let params = { skip: this.skip }

      if (this.gameFilter) params.filter = this.gameFilter
      if (this.systemFilter.length) params.systems = this.systemFilter

      const res = await this.$http.get('games', { params })

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'games', { handleMessage: this.$message.error })
        this.loadingGames = false
      }

      else {
        for (let game of res.list) {
          if (game.avatar && !this.gameIcons[game.avatar]) {
            this.gameIcons[game.avatar] = require(`@/assets/icon-${game.avatar}.png`)
          }

          if (this.systemIcons[game.systemAvatar]) continue
          this.systemIcons[game.systemAvatar] = require(`@/assets/${game.systemAvatar}-mini.png`)
        }

        if (this.skip) this.games = this.games.concat(res.list)
        else this.games = res.list

        this.gameFilterCurrent = this.gameFilter
        this.systemFilterCurrent = this.systemFilter

        this.skip = res.skip
        this.totalMatches = res.total

        this.done = res.done
        this.loadingGames = false
      }
    },

    setFilters (opt = {}) {
      // Set (new) filter
      if (('selected' in opt)) this.systemFilter = opt.selected
      if (('filter' in opt)) this.gameFilter = opt.filter
    },

    checkIfFiltersChanged () {
      // Check if game filter is changed
      let sameGameFilter = true

      if (this.gameFilterCurrent !== this.gameFilter) {
        sameGameFilter = false
      }

      // Check if system filter is changed
      let sameSystemFilter = true

      if (this.systemFilterCurrent.length !== this.systemFilter.length) {
        sameSystemFilter = false
      }

      if (sameSystemFilter) {
        let systemFilterMap = {}

        for (let system of this.systemFilterCurrent) {
          if (!systemFilterMap[system]) systemFilterMap[system] = 1
        }

        for (let system of this.systemFilter) {
          if (!systemFilterMap[system]) sameSystemFilter = false
        }
      }

      return sameGameFilter && sameSystemFilter
    }
  }
}
</script>
<style lang="scss">
@import '../styles/variables.scss';

.games-page {
  .el-select__input {
    color: $main-color-2;
  }

  .game-row {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: $main-color-2;
    padding-top: 10px;
  }

  .game-title {
    padding-right: 5px;
    text-align: left;
  }

  .game-system-index {
    font-size: 12px;
  }

  .game-system-avatar {
    margin-top: -10px;
    max-width: 40px;
  }

  .filter-element {
    margin-bottom: 7px;
    text-align: left;
  }

  .matched-results {
    text-shadow: #2d00ff 1px 0 10px;
  }

  .no-matched-results {
    text-shadow: #ff0000 1px 0 10px;
  }

  .game-title-filter {
    text-shadow: #2d00ff 1px 0 10px;
  }

  .grayed-filter {
    color: #c6bfbf;
  }

  .game-list-filter {
    max-width: 400px;
    .el-input__inner {
      border-left-width: 1px;
    }
  }

  .retro.el-button--primary{
    color: blue;
    background-color: #d4f1ff;
    border-color: blue;
  }

  .retro.el-button--primary:hover{
    color: #d4f1ff;
    background-color: blue;
    border-color: #d4f1ff;
  }

  .retro.el-button--danger{
    color: red;
    background-color: #ffe6e8;
    border-color: red;
  }

  .retro.el-button--danger:hover{
    color: #ffe6e8;
    background-color: red;
    border-color: #ffe6e8;
  }

  .retro.el-button--info{
    color: green;
    background-color: #f8fff7;
    border-color: green;
  }

  .retro.el-button--info:hover{
    color: $main-color-2;
    background-color: green;
    border-color:$main-color-2;
  }

  .game-avatar {
    margin-bottom: -5px;
    width: 20px;
    height: 20px;
  }

  .retro-status-button {
    font-size: 10px;
  }

  .game-action-status {
    font-size: 10px;
    margin-right: 10px;

    .el-input__inner {
      border-width: 0px;
    }
  }

  .game-title-finished {
    color: $main-color-2;
    text-shadow: #00ff4f 1px 0 10px;
  }

  .game-status-finished {
    /*background-color: #faffeb;*/
  }

  @media screen and (max-width: 61em) {
    .game-action-status {
      font-size: 16px !important;
      margin-right: 10px;
    }
  }
}
</style>
